import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { StyledAlertBox } from './AlertProvider.styles';

const AlertContext = React.createContext([]);

const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  return (
    <AlertContext.Provider value={[alert, setAlert]}>
      {alert && (
        <StyledAlertBox variant={alert.variant}>
          <span data-cy="payments-alert-message">
            <FormattedMessage id={alert.messageId} />
          </span>
        </StyledAlertBox>
      )}

      {children}
    </AlertContext.Provider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.node
};

export { AlertContext, AlertProvider };
